import React, { useEffect } from "react";
import "./styles.scss";

import OrderSummary from "../../component/cart/orderSummary";
import CartProductsList from "../../component/cart/productsList";
import { useStateValue } from "../../store/index";
import { getCartList } from "../../store/homeAction/action";
import { useNavigate } from "react-router-dom";

const MyCart = () => {
  const [{ cartListData }, dispatch] = useStateValue();
  const Navigate = useNavigate();
  useEffect(() => {
    // if (Object.keys(cartListData).length == 0) {
    dispatch({
      type: "SET_IS_LOADING",
      value: true,
    });
    let payload = {
      session_key: sessionStorage.getItem("session_key"),
    };
    getCartList((res, error) => {
      dispatch({
        type: "SET_CARTLIST_DATA",
        data: res,
      });
      sessionStorage.setItem(
        "iszipAuth",
        res?.data?.installation_content?.postal_code
      );
      dispatch({
        type: "SET_ZIP_CODE_POPUP",
        value: false,
        data: {
          installation: res?.data?.installation_content?.installation,
          fall_prevention: res?.data?.installation_content?.fall_prevention,
          zipCode: res?.data?.installation_content?.postal_code,
        },
      });
      dispatch({
        type: "SET_IS_LOADING",
        value: false,
      });
      if (error) {
        dispatch({
          type: "SET_ALERT_MESSAGE",
          value: true,
          data: {
            severity: "error",
            message: "Something went wrong, Please try again.",
          },
        });
      }
    }, payload);
    // }
  }, []);

  const handleProceedToCheckout = () => {
    let email_id = sessionStorage.getItem("is_auth_mail_id");
    let mail_id = sessionStorage.getItem("mail_id");
    if (email_id || mail_id) {
      // let session_key = sessionStorage.getItem("session_key");
      // let url = Constant.baseUrl() + `/checkedout/${session_key}`;
      // window.open(url, "_blank");
      Navigate(`${process.env.REACT_APP_BASE}/checkout`);
    } else {
      sessionStorage.setItem("is_auth_mail_id", true);
      dispatch({
        type: "SET_EMAIL_POPUP",
        value: true,
      });
    }
  };
  return (
    <div className="my-cart-container">
      {cartListData?.data?.order_summary && (
        <OrderSummary
          isValid={true}
          {...cartListData?.data?.order_summary}
          handleProceedToCheckout={handleProceedToCheckout}
        />
      )}
      {cartListData?.data?.Products && (
        <CartProductsList
          response={cartListData?.data?.Products}
          data={cartListData?.data?.installation_content}
        />
      )}
      {cartListData?.data?.order_summary && (
        <OrderSummary
          isValid={false}
          {...cartListData?.data?.order_summary}
          handleProceedToCheckout={handleProceedToCheckout}
        />
      )}
    </div>
  );
};

export default MyCart;
